<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style">
            <div class="content">
                <div class="row">

                    <div class="col-12 col-md-6 pe-0 mb-2">
                        <label for="">Surat</label>
                        <div class="form-custom form-label form-border form-icon mb-0">
                            <i class="bi bi-calendar font-12"></i>
                            <select v-model="selectedFilterSurat" @change="changeFilterSurat()" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                                <option value="0" selected="">Semua Surat</option>
                                <option v-for="item in quranSurahList" :key="item.id" :value="item.id">({{ item.no }}) {{ item.name }}</option>
                            </select>
                            <!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
                            <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 pe-0">
                        <label for="">Ayat</label>
                        <div class="form-custom form-label form-border form-icon mb-0">
                            <i class="bi bi-calendar font-12"></i>
                            <select v-model="selectedFilterAyat" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                                <option value="0" selected="">Semua Ayat</option>
                                <option v-for="item in quranSurahAyatList" :key="item.id" :value="item.id">{{ item.no }}</option>
                            </select>
                            <!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
                            <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3">
                        <button @click="searchSuratAyat()" class="btn w-100 btn-sm bg-green-light mt-3">Cari</button>
                    </div>

                </div>
            </div>
        </div>

        <div class="card card-style">
            <div class="content mt-3">
				<div class="tabs tabs-box" id="tab-mode-surah">
					<div class="tab-controls rounded-s border-highlight">
						<a @click.prevent="setActive('translate')" :aria-expanded="isActive('translate')" class="font-13 color-highlight" href="#">Terjemah</a>
						<a @click.prevent="setActive('read')" :aria-expanded="isActive('read')" class="font-13 color-highlight" href="#">Mode Baca</a>
					</div>

					<div class="mt-3"></div>

					<div class="collapse" :class="{ 'show': isActive('translate') }">
                        <div v-for="(items, index)  in quranSurahDetail" :key="items.id">
                            <div class="d-flex justify-content-between mb-2">
                                <div class="d-flex align-items-center">
                                    <!-- <h6 class="mb-0"><span class="border border-dark p-1 px-2">{{ items.no }} : {{ arrSuratIdName[items.surat_id] }}</span></h6> -->
                                    <h3 
                                        style="cursor:pointer;" 
                                        class="mb-0 font-29" 
                                        data-bs-toggle="offcanvas" 
                                        :data-bs-target="`#toggle-ayat${index}`"
                                    >
                                        <span class="badge bg-blue-light rounded-s p-2 px-2">
                                            <span class="font-16">{{ items.no }}</span> : {{ arrSuratIdName[items.surat_id] }}
                                        </span>
                                    </h3>
                                    <!-- <a href="#" ref="PlayBtnAudio" v-if="surah_audio_url.length > 0 && surah_audio_url[index] != undefined" @click="playSurahAudioCurrent(index)" class="icon icon-xxs bg-highlight rounded-xs ms-2"><i class="bi bi-play-fill"></i></a>
                                    <a href="#" ref="PauseBtnAudio" v-if="surah_audio_url.length > 0 && surah_audio_url[index] != undefined" @click="pauseAudioControl(index)" class="d-none icon icon-xxs bg-red-dark rounded-xs ms-2"><i class="bi bi-pause-fill"></i></a> -->
                                </div>

                                <div class="d-flex align-items-center">
                                    <!-- <a href="#" v-if="$store.state.token" class="icon icon-xxs bg-highlight rounded-xs me-2"><i class="bi bi-bookmark"></i></a> -->
                                    <!-- <a href="#" v-if="$store.state.token" class="icon icon-xxs border-highlight border color-highlight rounded-xs me-2"><i class="bi bi-bookmark"></i></a>
                                    <i class="bi bi-share-fill bg-hi fs-5"></i> -->
                                </div>
                            </div>

                            <Portal to="offcanvas-modal-bottom" :order="index">
                                <div :id="`toggle-ayat${index}`" class="offcanvas offcanvas-bottom offcanvas-detached rounded-m overflow-hidden">
                                    <div class="content">
                                        <div class="d-flex pb-2">
                                            <div class="align-self-center">
                                                <!-- <h5 class="mb-n1 font-12 color-highlight font-700 text-uppercase pt-1">Just tap and</h5> -->
                                                <h2 class="mb-0 font-38">
                                                    <span class="badge bg-yellow-light text-dark rounded-s p-2 px-2">
                                                        <span class="font-20">{{ items.no }}</span> : {{ arrSuratIdName[items.surat_id] }}
                                                    </span>
                                                </h2>
                                            </div>
                                            <div class="align-self-center ms-auto">
                                                <a href="#"  data-bs-dismiss="offcanvas" class="icon icon-m"><i class="bi bi-x-circle-fill color-red-dark font-18 me-n4"></i></a>
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-between flex-column">
                                            <a href="javascript:void(0);" ref="PlayBtnAudio" v-if="surah_audio_url.length > 0 && surah_audio_url[index] != undefined" @click="playSurahAudioCurrent(index)" class="btn btn-xxs bg-blue-dark shadow-bg-m text-start d-flex align-items-center">
                                                <i class="bi bi-play-circle-fill font-18 me-2"></i> Dengarkan
                                            </a>
                                            <a href="javascript:void(0);" ref="PauseBtnAudio" v-if="surah_audio_url.length > 0 && surah_audio_url[index] != undefined" @click="pauseAudioControl(index)" class="d-none btn btn-xxs bg-blue-dark shadow-bg-m text-start d-flex align-items-center">
                                                <i class="bi bi-pause-circle-fill font-18 me-2"></i> Berhenti
                                            </a>

                                            <a href="javascript:void(0);" class="btn btn-xxs bg-green-dark shadow-bg-m text-start d-flex align-items-center mt-2"><i class="bi bi-share-fill font-18 me-2"></i> Bagikan</a>
                                            <a href="javascript:void(0);" @click="saveBookmarkQuranAyata(items.id, items.bookmark_ayat)" v-if="$store.state.token" class="btn btn-xxs bg-yellow-dark shadow-bg-m text-start d-flex align-items-center mt-2">
                                                <i :class="{ 'bi-bookmark-fill': items.bookmark_ayat != null, 'bi-bookmark': items.bookmark_ayat == null }" class="bi font-18 me-2"></i> 
                                                Simpan Terakhir Baca
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </Portal>

                            <div class="row" v-if="terjemahan_kata" dir="rtl">
                                <div class="col-lg-12">
                                    <div v-for="kata in items.kata" :key="kata.id" class="badge bg-arab float-right m-1" 
                                    >
                                        <h1 class="arab text-dark" v-if="harokat">{{ kata.arab_harokat }}</h1>
                                        <h1 class="arab" v-if="!harokat">{{ kata.arab }}</h1>
                                        <!-- <div v-html="kata.basic_word"></div> -->
                                        <p class="text-black-50 text-terjemahan teksTerjemah" v-html="kata.indonesia"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="!terjemahan_kata" dir="rtl">
                                <div class="col-lg-12">
                                    <h1 v-if="harokat" class="d-flex flex-wrap mb-2" style="white-space: nowrap;">
                                        <span class="arab" style="padding: 2px;" v-for="kata in items.kata" :key="kata.id">{{ kata.arab_harokat }}</span>
                                    </h1>
                                    <h1 v-if="!harokat" class="d-flex flex-wrap mb-2" style="white-space: nowrap;">
                                        <span class="arab" style="padding: 2px;" v-for="kata in items.kata" :key="kata.id">{{ kata.arab }}</span>
                                    </h1>
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-end">
                                <div class="mt-2" v-if="terjemahan_bait" v-html="items.translation"></div>
                                <div class="d-flex flex-start mt-3" v-if="detail">
                                    <i class="bi bi-info-circle-fill text-warning fs-5"></i>
                                    <button @click="showDetailDescription(index, items.tafsir)" v-if="items.tafsir != '-'" class="btn-full btn-xxs btn border border-red-dark color-red-dark mx-1" style="white-space: nowrap;font-size: 10px;line-height: 1;padding: 4px 10px;border-radius: 5px;">Tafsir</button>
                                    <button @click="showDetailDescription(index, items.asbabun_nuzul)" v-if="items.asbabun_nuzul != '-'" class="btn-full btn-xxs btn border border-red-dark color-red-dark mx-1" style="white-space: nowrap;font-size: 10px;line-height: 1;padding: 4px 10px;border-radius: 5px;">Asbabun Nuzul</button>
                                    <button @click="showDetailDescription(index, items.nasih_mansuh)" v-if="items.nasih_mansuh != '-'" class="btn-full btn-xxs btn border border-red-dark color-red-dark mx-1" style="white-space: nowrap;font-size: 10px;line-height: 1;padding: 4px 10px;border-radius: 5px;">Nasih Mansuh</button>
                                </div>
    
                                <div ref="detailDescription" class="d-none card bg-gray-light mt-3" style="background-color: #f4f4f4 !important;">
                                    <div class="content m-1 mx-2">
                                        <p ref="contentDetailDescription" class="color-dark-light"></p>
                                    </div>
                                </div>
                            </div>

                            <hr>
                        </div>
                    </div>

					<div class="collapse" :class="{ 'show': isActive('read') }">
                        <div class="flex-wrap" dir="rtl">
                            <p class="flex-wrap mb-2">
                            <span  v-for="items in quranSurahDetail" :key="items.id">
                                <!-- <h3 class="d-flex flex-wrap mb-2" style="white-space: nowrap;"> -->
                                    <span class="arab" style="padding: 2px;" v-for="kata in items.kata" :key="kata.id">{{ kata.arab_harokat }} </span>
                                    <span class="border border-dark p-1 px-2 mx-2" style="font-size: 13px !important;">{{ items.no }}</span>
                                <!-- </h3> -->
                            </span>
                            </p>
                        </div>
                    </div>

				</div>
			</div>

        </div>

        <div v-for="(audio_url, index) in surah_audio_url" :key="index">
            <audio 
                ref="audio" 
                v-if="audio_url.length != 0" 
                @play="playAudioControl(index)" 
                @pause="pauseAudioControl(index)" 
                @ended="endedAudioControl()"
                controls 
                class="audio-control"
                v-bind:class="[index_surah_audio_current != index ? 'd-none' : '']"
            >
                <source :src="audio_url" type="audio/mpeg">
                Your browser does not support the audio element.
            </audio>
        </div>

        <div class="d-flex justify-content-evenly py-2 paggination">
            <i v-if="prev_page_url" @click="PagginationSurah('prev')" class="bi bi-arrow-left-square-fill fs-5"></i>
            <div class="d-flex align-items-center">
                <h4>Halaman : {{ page }}</h4>
                <a href="#" v-if="$store.state.token" @click="saveBookmarkQuranSurahPage()" class="ms-2 icon icon-xxs border-highlight border color-highlight rounded-xs me-2"><i class="bi bi-bookmark"></i></a>
            </div>
            <i v-if="next_page_url" @click="PagginationSurah('next')" class="bi bi-arrow-right-square-fill fs-5"></i>
        </div>

    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'QuranDetail',
    props: ['title'],
    data(){
        return {
            detail_description: [],
            surah_audio_url: [],
            index_surah_audio_current: 0,
            activeTab: 'translate',
            // index_surah_audio_url: null
            selectedFilterSurat: 0,
            selectedFilterAyat: 0,
            arrSuratIdName: [],
            indexToggleAyat: 0,
        }
    },
    async created() {
        await this.getQuranSurahList()
                .then(data => {
                    data.data.forEach((surat) => {
                        this.arrSuratIdName[surat.id] = surat.arab
                    })
                })

        await this.getQuranSurahDetail(this.$route.params.id)
                .then(data => {
                    // for (const key in data.data) {
                    //     if (Object.hasOwnProperty.call(data.data, key)) {
                    //         const ayat = data.data[key];
                            
                    //         // this.detail_description[ayat.id] = null
                    //     }
                    // }

                    data.data.data.map((value) => { 
                        if (value.audio_url.length > 0) {
                            this.surah_audio_url.push(value.audio_url) 
                        }
                    })
                })
    },
    methods: {
        ...mapActions('quranSurah', ['getQuranSurahDetail', 'getQuranSurahList']),
        ...mapActions('quranAyat', ['getQuranAyatBySurat']),
        ...mapActions('bookmark', ['saveBookmarkPage', 'createBookmarkAyat', 'deleteBookmarkAyat']),
        isActive (menuItem) {
            return this.activeTab === menuItem
        },
        setActive (menuItem) {
            this.activeTab = menuItem
        },
        showDetailDescription(index, description) {
            this.$refs.detailDescription[index].classList.remove('d-none')
            this.$refs.contentDetailDescription[index].innerHTML = description
        },
        PagginationSurah(for_do) {
            let page = (for_do == 'prev') ? parseInt(this.page) - 1 : parseInt(this.page) + 1

            if(this.selectedFilterSurat == 0) {
                this.getQuranSurahDetail([this.$route.params.id, page])
            } else this.getQuranSurahDetail([this.selectedFilterSurat, page, this.selectedFilterAyat]);
        },
        playSurahAudioCurrent(index_surah_audio_url) {
            // this.index_surah_audio_current = this.surah_audio_url[index_surah_audio_url]
            // document.getElementById("surah_audio_control").play()
            
            // this.handlePlaySurahAudio(index_surah_audio_url)
            this.$refs.audio[index_surah_audio_url].play()
        },
        playAudioControl(index_surah_audio_url) {
            this.handlePlaySurahAudio(index_surah_audio_url)
        },
        pauseAudioControl(index_surah_audio_url) {
            this.$refs.audio[index_surah_audio_url].pause()

            this.$refs.PlayBtnAudio[index_surah_audio_url].classList.remove('d-none')
            this.$refs.PauseBtnAudio[index_surah_audio_url].classList.add('d-none')
        },
        handlePlaySurahAudio(index_surah_audio_url) {
            this.index_surah_audio_current = index_surah_audio_url

            let PlayBtnAudio = this.$refs.PlayBtnAudio
            let PauseBtnAudio = this.$refs.PauseBtnAudio
            this.$refs.audio.forEach((element, index) => {
                if (index != index_surah_audio_url) {
                    element.style.display = "none"
                    element.pause()

                    PlayBtnAudio[index].classList.remove('d-none')
                    PauseBtnAudio[index].classList.add('d-none')
                } else {
                    element.style.display = "block"
                    element.play()

                    PlayBtnAudio[index].classList.add('d-none')
                    PauseBtnAudio[index].classList.remove('d-none')
                }
            })
        },
        endedAudioControl() {
            ++this.index_surah_audio_current

            if (this.index_surah_audio_current >= this.surah_audio_url.length) {
                this.index_surah_audio_current = 0
            }
            this.$refs.audio[this.index_surah_audio_current].play()
        },
        saveBookmarkQuranSurahPage() {
            this.saveBookmarkPage({
                'type': 'alquran',
                'surat_id': this.$route.params.id,
                'page': this.page 
            })
        },
        saveBookmarkQuranAyata(ayat_id, status) {
            if(status == null) this.createBookmarkAyat({ ayat_id });
            else this.deleteBookmarkAyat({ ayat_id });
        },
        changeFilterSurat() {
            this.getQuranAyatBySurat(this.selectedFilterSurat)
        },
        searchSuratAyat() {
            if(this.selectedFilterSurat == 0) {
                this.getQuranSurahDetail(this.$route.params.id)
                .then(data => {
                    data.data.data.map((value) => { 
                        if (value.audio_url.length > 0) {
                            this.surah_audio_url.push(value.audio_url) 
                        }
                    })
                })
            } else if(this.selectedFilterAyat == 0) {
                this.getQuranSurahDetail([this.selectedFilterSurat, this.page]);
            } else this.getQuranSurahDetail([this.selectedFilterSurat, this.page, this.selectedFilterAyat]);
        },
        toggleActionAyat(indexAyat) {
            this.indexToggleAyat = indexAyat
        }
    },
    computed: {
        ...mapState('quranSurah', {
            quranSurahDetail: state => state.quranSurahDetail,
            page : state => state.page,
            prev_page_url : state => state.prev_page_url,
            next_page_url : state => state.next_page_url,
            quranSurahList : state => state.quranSurahList,
        }),
        ...mapState('quranAyat', {
            quranSurahAyatList: state => state.quranSurahAyatList
        }),
        ...mapState([
            'terjemahan_bait', 'terjemahan_kata', 'harokat', 'detail'
        ])
    }
}
</script>

<style scoped>
.page-content {
  padding-bottom: 146px;
}

.audio-control {
    position: fixed;
    bottom: 106px;
    width: 100%;
    right: 0;
    left: 0;
}
.audio-control-detached {
    left: 10px !important;
    right: 10px !important;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
}

.paggination {
    position: fixed;
    bottom: 60px;
    /* width: 100%; */
    right: 0;
    left: 0;
    background-color: white;
    border: 1px solid #cecece;
}
.paggination-detached {
    left: 10px !important;
    right: 10px !important;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 25px;
}

.arab {
    margin-top : 0.5rem;
}
.arab_count {
    padding : 1px;
    /* margin-bottom: 10px; */
}
.arab-first {
    color: red !important; 
}
</style>
